const BlueButtonComp = ({
   btnBoxSize = {},
   btnText,
   onClick = () => {},
   fullWidth = false,
   loading = false,
   id = "button-new",
}) => {
   return (
      <button
         id={id}
         onClick={onClick}
         width={fullWidth ? "100%" : ""}
         className={` vtwo-blue-button vtwo-center-flex ${btnBoxSize}`}
      >
         {loading ? <AsyncLoader /> : btnText}
      </button>
   );
};

export const AsyncLoader = () => (
   <div style={{ width: "2.5rem", height: "2.5rem" }} className="spinner-border  loader-color-v2"></div>
);
export const AsyncLoaderBlue = () => (
   <div style={{ width: "2.5rem", height: "2.5rem" }} className="spinner-border  loader-color"></div>
);

export default BlueButtonComp;
